const lengthPassword = 8;

function checkDoublePassword(pwdOne,pwdTwo){
    return (pwdOne === pwdTwo);
}

function verifLengthPassword(mdp){
    return mdp.length >= lengthPassword;
}

function verifContainsSpecialCharacter(mdp){
    return /^[a-zA-Z0-9- ]*$/.test(mdp) === false;
}

function verifName(name){
    return /^[a-zA-Zéàâôêîïù]*$/.test(name) === true && name != "";
}

function isNumber(mdp){
    let tmp = 0;
    let char ='';
    while(tmp < mdp.length){verifName
        char = mdp[tmp];
        if( typeof(char) != "boolean" && !isNaN(char) && char != " "){
            return true;
        }
        tmp++;
    }
    return false;
}

function verifPassword(mdp){
    return verifLengthPassword(mdp) && verifContainsSpecialCharacter(mdp) && isNumber(mdp);
}

module.exports = {verifName,isNumber,verifContainsSpecialCharacter,verifLengthPassword,checkDoublePassword,verifPassword}